<script lang="ts" setup>
import type { FaqItem } from '#forgd/app/utils/faqs'
import { SHARED_FAQS } from '#forgd/app/utils/faqs'

const FAQS: FaqItem[] = [
  SHARED_FAQS.whatIsForgd,
  SHARED_FAQS.freeAccount,
  SHARED_FAQS.selfServiceProducts,
  SHARED_FAQS.consultingServices,
  SHARED_FAQS.tokenomicsDesign,
  SHARED_FAQS.hireMarketMaker,
  {
    question: 'Can I still use Forgd if my token is already listed?',
    answer: [
      'Yes, Forgd is designed to support projects at any stage, including post-listing. Our platform offers tools for liquidity management, performance monitoring, and strategic advisory services that are beneficial for managing and scaling your token effectively even after it is listed.',
    ],
  },
  {
    question: 'How can Forgd help me list my token on exchanges?',
    answer: [
      'Forgd assists with exchange listings by providing strategic guidance and direct connections to major exchanges. Our platform supports projects through the listing process, from preparing applications to negotiating terms, ensuring a smooth and successful token listing experience.',
    ],
  },
  {
    question: 'What services does Forgd offer to blockchain entrepreneurs?',
    answer: [
      'Forgd provides a range of tools and services designed to assist at every stage of a blockchain project, including tokenomics, market maker engagement, exchange listing support, token streaming, market maker monitoring, and more.',
    ],
  },
  {
    question: 'Is Forgd an incubator?',
    answer: [
      'Forgd functions as a comprehensive advisory platform rather than a traditional incubator. It provides tools and services to support blockchain projects from token design to market launch, focusing on empowering projects through technology rather than direct incubation.',
    ],
  },
  SHARED_FAQS.scheduleConsultation,
  {
    question: 'Does my project need to issue a token to work with Forgd?',
    answer: [
      'No, your project does not need to issue a token to benefit from Forgd\'s services. Our platform supports a wide range of blockchain and crypto-related initiatives, whether or not they involve a native token.',
    ],
  },
]
</script>

<template>
  <section class="flex flex-col md:gap-5">
    <h2 class="-mx-4 flex items-center border-b border-default p-2 text-md font-semibold text-primal md:mx-0 md:border-b-0 md:p-0 md:text-xl">
      Frequently Asked Questions
    </h2>
    <CoreFaqAccordion :faqs="FAQS" layout="split" />
  </section>
</template>
